import { Control } from "react-hook-form";
import { EnteredRecordEntityFilterForm } from "./EnteredRecordEntityFilterForm";
import { ModificationRecordEntityFilterForm } from "./ModificationRecordEntityFilterForm";
import { ICombinedModificationRecordEntityForm } from "./CombinedModificationRecordEntityFilterFormModels";
import { FoldableFilters } from "./common/FoldableFilters";

export const CombinedModificationRecordEntityFilterForm = <FormValues extends ICombinedModificationRecordEntityForm>({
  control,
  currentTab,
  initialValues,
}: {
  control: Control<any, any, any>;
  currentTab: any;
  initialValues?: FormValues;
}) => {
  const stateArray = [
    !!initialValues?.enteredByIds?.length,
    !!initialValues?.enteredFrom,
    !!initialValues?.enteredTo,
    !!initialValues?.modifiedByIds?.length,
    !!initialValues?.modifiedFrom,
    !!initialValues?.modifiedTo,
  ];
  return (
    <FoldableFilters label="Record information" defaultOpen={stateArray.some((p) => p) && !!stateArray.length}>
      <EnteredRecordEntityFilterForm control={control} currentTab={currentTab} />

      <ModificationRecordEntityFilterForm control={control} />
    </FoldableFilters>
  );
};
